import api from '../api/client';

const POST_AUTH_NOTICE_KEY = 'postAuthRedirectNotice';

const PATH_FEATURE_FLAGS = {
  '/marketplace/apply': 'interviewer_marketplace',
  '/hiring': 'hiring_marketplace',
};

/** Signup-intent destinations must not be blocked after referral/OAuth signup. */
const SIGNUP_INTENT_PATHS = new Set(['/marketplace/apply', '/hiring']);

export const setPostAuthRedirectNotice = (message) => {
  if (!message) return;
  sessionStorage.setItem(POST_AUTH_NOTICE_KEY, message);
};

export const consumePostAuthRedirectNotice = () => {
  const message = sessionStorage.getItem(POST_AUTH_NOTICE_KEY);
  sessionStorage.removeItem(POST_AUTH_NOTICE_KEY);
  return message || null;
};

/**
 * If the target path requires a disabled feature flag, fall back to dashboard with a notice.
 */
export const resolveRedirectWithFeatureFlags = async (path) => {
  if (SIGNUP_INTENT_PATHS.has(path)) {
    return { path, featureDisabled: false };
  }

  const flagKey = PATH_FEATURE_FLAGS[path];
  if (!flagKey) {
    return { path, featureDisabled: false };
  }

  try {
    const { data } = await api.featureFlags.check(flagKey);
    if (data?.enabled) {
      return { path, featureDisabled: false };
    }
    setPostAuthRedirectNotice(
      'That feature is not available right now. You have been sent to your dashboard.'
    );
    return { path: '/dashboard', featureDisabled: true };
  } catch {
    // Fail open after OAuth/signup so a transient auth race does not drop signup intent.
    return { path, featureDisabled: false };
  }
};
